
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android",
      function () {
        return require("private-next-pages/android/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android"])
      });
    }
  